import {sendStats} from '@github-ui/stats'
import {sendToHydro} from './hydro-stats'
import {wasServerRendered} from '@github-ui/ssr-utils'
import {shouldReportLongTask} from './utils/suppression'

export const observeLongTasks = () => {
  if (
    typeof PerformanceObserver !== 'undefined' &&
    (PerformanceObserver.supportedEntryTypes || []).includes('longtask')
  ) {
    const observer = new PerformanceObserver(function (list) {
      const longTasksEntries = list.getEntries()
      // Filter out non-representative long tasks (debugger pauses, extreme durations)
      const filteredEntries = longTasksEntries.filter(entry => shouldReportLongTask(entry))
      const longTasks = filteredEntries.map(({name, duration}) => ({name, duration, url: window.location.href}))

      if (longTasks.length > 0) {
        sendStats({longTasks})
        sendToHydro({longTasks: filteredEntries, ssr: wasServerRendered()})
      }
    })
    observer.observe({type: 'longtask', buffered: true})
  }
}
